import api from "../api";

const API_BASE = "/api/Usuarios";

const login = async function (userData: { [key: string]: string }) {
  const authData = `${userData.email}:${userData.password}`;
  const base64string = `Custom ${btoa(authData)}`;

  return api.post(
    `${API_BASE}/Autenticacao`,
    {},
    {
      headers: {
        Authorization: base64string,
      },
    },
  );
};

const createAccount = async function (userData: { [key: string]: string | boolean }) {
  return api.post(`${API_BASE}/RequestAccess`, userData);
};

const recoverPassword = async function (userData: { [key: string]: string }) {
  return api.post(`${API_BASE}/ResetPassword`, userData);
};

const updatePassword = async function (userData: { [key: string]: string | boolean }) {
  return api.put(`${API_BASE}/PasswordChange`, {
    Senha: userData.oldPassword,
    NovaSenha: userData.newPassword,
    ConfirmacaoNovaSenha: userData.newPasswordConfirmation,
  });
};

const deleteAccount = async function (userData: { [key: string]: string }) {
  return api.delete(`${API_BASE}/DeleteAccount`, {
    data: { email: userData.email, senha: userData.password },
  });
};

const getUserData = async function () {
  return api.get(API_BASE);
};

const updateUserData = async function (userData: { [key: string]: string | boolean }) {
  return api.put(API_BASE, userData);
};

const usuarioService = {
  login,
  createAccount,
  recoverPassword,
  updatePassword,
  getUserData,
  deleteAccount,
  updateUserData,
};

export default usuarioService;
